import Vue from 'vue'

import createDefaultState from './state'

export const reset = (state) => {
  Object.assign(state, createDefaultState())
}

export * from '@/utils/store/concerns/loadable/mutations'

export const setData = (state, data) => {
  if (!data) return

  state.earnsAndBurns = data.earns_and_burns
  state.cachedBenefits = data.cached_benefits
}

export const updateProgramCachedBenefits = (
  state,
  { identifier, benefits }
) => {
  Vue.set(state.cachedBenefits, identifier, benefits)
}
